import { all } from "redux-saga/effects"

import leadsSaga from "./leads/saga"

export const rootSaga = function* () {
  yield all([...leadsSaga])
}
